import React, { useEffect, useState } from 'react';
import { CContainer, CBreadcrumb, CBreadcrumbItem, 
  CCard, CCardHeader, CCardBody, CRow, CCol } from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';
import ProductInputs from '../../components/ProductInputs/ProductInputs';
import { addProductRequest } from '../../store/product/productActions';
import { getProductDropdown } from '../../services/endpoints';

const CreateProduct = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isLoading = useSelector(state => state.productReducer.isLoading);
  const submitResponse = useSelector(state => state.productReducer.addProductData);

  const [weaveOptions, setWeaveOptions] = useState([]);
  const [materialOptions, setMaterialOptions] = useState([]);
  const [dropdownLoading, setDropdownLoading] = useState(true);
  const [dropdownError, setDropdownError] = useState(null);
  const [colorOptions, setColorOptions] = useState([]);
  const [yarnOptions, setYarnOptions] = useState([]);

  const fetchWeavesByCode = async (weaveCode) => {
    const sessionUserId = localStorage.getItem('sessionUserId');
    const response = await getProductDropdown
    ({ SessionUserId: sessionUserId, WeaveCode: weaveCode || '' });
    return response?.data?.Weaves || [];
  };

  useEffect(() => {
    const fetchDropdown = async () => {
      setDropdownLoading(true);
      setDropdownError(null);
      try {
        const sessionUserId = localStorage.getItem('sessionUserId');
        const response = await getProductDropdown({ SessionUserId: sessionUserId, WeaveCode: '' });
        if (response && response.data && response.data.Weaves) 
        setWeaveOptions(response.data.Weaves);
        if (response && response.data && response.data.Materials) 
        setMaterialOptions(response.data.Materials);
        if (response && response.data && response.data.Colors)
        setColorOptions(response.data.Colors);
        if (response && response.data && response.data.Yarns)
        setYarnOptions(response.data.Yarns);
      } catch (err) {
        setDropdownError('Dropdown verileri alınamadı.');
      } finally {
        setDropdownLoading(false);
      }
    };
    fetchDropdown();
  }, []);

  const handleWeaveSearch = async (searchTerm) => {
    try {
      const weaves = await fetchWeavesByCode(searchTerm);
      setWeaveOptions(weaves);
    } catch (err) {
      setWeaveOptions([]);
    }
  };

  const handleSubmit = (data) => {
    dispatch(addProductRequest({ ...data, navigate }));
  };

  const handleCancel = () => {
    navigate('/products');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/products" 
        onClick={e => { e.preventDefault(); handleCancel(); }}>{t('products')}</CBreadcrumbItem>
        <CBreadcrumbItem active>{t('createProduct')}</CBreadcrumbItem>
      </CBreadcrumb>
      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader><h4>{t('createProduct')}</h4></CCardHeader>
            <CCardBody>
              <ProductInputs onSubmit={handleSubmit}
               onCancel={handleCancel} isLoading={isLoading} 
               submitResponse={submitResponse}
               weaveOptions={weaveOptions}
               materialOptions={materialOptions}
               colorOptions={colorOptions}
               yarnOptions={yarnOptions}
               dropdownLoading={dropdownLoading}
               dropdownError={dropdownError}
              onWeaveSearch={handleWeaveSearch}
            />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

export default CreateProduct; 